module.exports = __webpack_public_path__ + "media/country_flags/bj-4f213c03.png";